export default "__VITE_ASSET__BRFBkLNE__"